import React from 'react'
import { graphql, compose } from 'react-apollo'
import { translate } from 'react-i18next'

import config from '../../config'

import Loader from '../UI/Loader'
import Form from '../UI/Form'
import FileUploadInput from '../UI/FileUploadInput'
import ImgBankPhotoSelectionModal from '../ImgBankPhotoSelection/ImgBankPhotoSelectionModal'

import GUIDE_PROFILE_BY_USER from './../../graphql/GuideProfileByUser.graphql'
import UPDATE_USER_PROFILE_QUERY from './../../graphql/UpdateGuideProfilePhotos.graphql'
import DELETE_FILE_QUERY from './../../graphql/DeleteFile.graphql'

class PhotosForm extends React.Component {
  state = {
    routeIndex: 3,
    saving: false,
    photos: [{}, {}, {}]
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data && nextProps.data.user && nextProps.data.user.guideProfile && nextProps.data.user.guideProfile.photos) {
      let photos = []
      if (nextProps.data.user.guideProfile.photos.length < 3) {
        photos = [...nextProps.data.user.guideProfile.photos]

        for (let i = 0; i < 3 - nextProps.data.user.guideProfile.photos.length; i++) {
          photos.push({})
        }
      } else {
        photos = nextProps.data.user.guideProfile.photos
      }
      this.setState({
        photos: photos
      })
    }
  }

  handleSubmit = () => {
    this.props.validate(this.state.routeIndex, true)
    this.setState({
      saving: true
    })
    if (this.state.photos[0].name) {
      let promises = this.state.photos
        .filter(photo => {
          return !photo.id && photo.name
        })
        .map(file => {
          return new Promise((resolve, reject) => {
            let data = new FormData()
            data.append('data', file)
            resolve(
              fetch(config.fileAPI, {
                method: 'POST',
                body: data
              })
            )
          }).then(res => res.json())
        })

      Promise.all(promises)
        .then(result => {
          return result.map(file => file.id)
        })
        .then(fileIds => {
          let photosIds = this.state.photos.filter(photo => photo.id).map(photo => photo.id)

          fileIds.forEach(id => {
            photosIds.push(id)
          })
          return this.props.updateGuideProfile({
            variables: {
              id: this.props.data.user.guideProfile.id,
              photosIds: photosIds
            }
          })
        })
        .then(() => {
          this.props.history.push('/activity-guide-profile/languages')
        })
    } else {
      this.setState({
        vlidationError: 'Must have at least one photo',
        saving: false
      })
    }
  }

  handleChange(e, index) {
    let photos = [...this.state.photos]

    photos[index] = e[0]
    let reader = new FileReader()
    reader.onload = function(e) {
      photos[index].src = e.target.result

      this.setState({
        photos: photos
      })
    }.bind(this)

    reader.readAsDataURL(e[0])
  }

  removePhoto = (e, index) => {
    let photos = [...this.state.photos]

    if (photos[index].id) {
      this.props
        .deleteFile({
          variables: {
            id: photos[index].id
          }
        })
        .then(() => {
          photos[index] = {}

          this.setState({
            photos: photos
          })
        })
    } else {
      photos[index] = {}

      this.setState(
        {
          photos: photos
        },
        () => {
          this.props.updateSteps({
            photos: this.state.photos
          })
        }
      )
    }
  }

  closeModal = index => {
    const imgModal = {}
    imgModal['imgModal' + index] = false
    this.setState(imgModal)
  }

  render() {
    if (this.props.data.loading) {
      return <Loader showLoader={true} />
    }
    const { t, data } = this.props
    const { saving, imgModal } = this.state
    return (
      <div className="steps-screen__form">
        <div className="steps-screen__form-title">{t('add_photos')}</div>

        <div className="form-subtitle-bold">{t('quality_photos')}</div>
        <div className="form-subtitle-last">{t('chance_picked')}</div>

        <div className="steps-screen__form-input-area photos__form">
          {this.state.photos.map((photo, index) => (
            <div className="photo-upload" key={index}>
              <div className={photo.url || photo.src ? 'hidden' : 'photo-wrapper'}>
                <div
                  className="missing-photo"
                  onClick={e => {
                    let imgModal = {}
                    imgModal['imgModal' + index] = true
                    this.setState(imgModal)
                  }}
                >
                  <i className="icon-plus" />
                </div>

                <ImgBankPhotoSelectionModal
                  id={'file' + index}
                  user={data.user}
                  isOpen={this.state['imgModal' + index]}
                  index={index}
                  onClose={this.closeModal}
                  onFileChange={e => this.handleChange(e, index)}
                  t={t}
                />
              </div>

              <div className={photo.url || photo.src ? 'photo-upload__image-wrapper' : 'hidden'}>
                <img src={photo.url || photo.src} className={photo.url || photo.src ? 'photo-upload__image' : 'hidden'} />

                {(photo.url || photo.src) && (
                  <button disabled={saving} className="photo-upload__remove-btn" onClick={e => this.removePhoto(e, index)}>
                    <i className="icon-plus" />
                    {t('main:remove')}
                  </button>
                )}
              </div>
            </div>
          ))}
          <div>Please select at least one picture.</div>
        </div>
        <small className="text-danger">{this.state.vlidationError}</small>
        <button style={{ marginTop: '25px' }} onClick={() => this.handleSubmit()} className="btn btn-lg btn-primary btn-danger">
          {t('main:save_continue')}
        </button>
      </div>
    )
  }
}

export default compose(
  translate('guide'),
  graphql(UPDATE_USER_PROFILE_QUERY, {
    name: 'updateGuideProfile'
  }),
  graphql(GUIDE_PROFILE_BY_USER, {
    options: {
      fetchPolicy: 'network-only'
    }
  }),
  graphql(DELETE_FILE_QUERY, {
    name: 'deleteFile'
  })
)(PhotosForm)



// WEBPACK FOOTER //
// src/components/Guide/PhotosForm.jsx